import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from '../services/oauth.service';
import {environment} from "../../environments/environment";

@Injectable()

export class CanActivateViaOAuthGuard implements CanActivate {

  constructor(private router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (OAuthService.getAccessToken()) {
      const roles = JSON.parse(localStorage.getItem('roles'));
      if (roles != undefined && roles != null && this.isAdmin(roles)) {
        if (state.url.search('/form/startInstance/') < 0)
          window.location.href=environment.url.adminHome;
      }
      return true;
    }

    // not logged in so redirect to login page with the return url
    // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    this.router.navigate(['/login']);
    return false;
  }

  isAdmin(roles) {
    const isAdmin = roles.filter(role => {
      return role === 'F' || role === 'A' || role === 'E' || role === 'X' || role === 'Y';
    })[0];
    return isAdmin;
  }
}
